import {
  Flame,
  Shield,
  Briefcase,
  GraduationCap,
  HeartPulse,
  Pill,
} from "lucide-react";

/**
 * Section D — "Who we see".
 * Placed directly after the existing "Adjunctive treatment" section.
 * 6-tile grid (3 desktop, 2 tablet, 1 mobile) with simple line icons.
 */
const tiles = [
  {
    icon: Flame,
    title: "A first responder",
    body: "Firefighters, police, EMS and dispatchers who absorb other people's worst days as part of the job",
  },
  {
    icon: Shield,
    title: "A Veteran or service member",
    body: "We're in-network with the VA",
  },
  {
    icon: Briefcase,
    title: "A high-functioning professional",
    body: "Still performing at work, but running on empty everywhere else",
  },
  {
    icon: GraduationCap,
    title: "A college student or young adult",
    body: "Dealing with trauma or a flatness that started during school",
  },
  {
    icon: HeartPulse,
    title: "A survivor",
    body: "Of assault, an accident, a medical crisis, a loss or a natural disaster",
  },
  {
    icon: Pill,
    title: "Someone who's already tried therapy, medication or both",
    body: "And is still carrying more than they should",
  },
];

export default function WhoWeSeeSection() {
  return (
    <section
      className="relative bg-background py-16 lg:py-24"
      aria-labelledby="prism-who-we-see-heading"
    >
      <div className="container-px mx-auto max-w-5xl">
        <div className="max-w-3xl">
          <h2
            id="prism-who-we-see-heading"
            className="font-headings text-2xl font-bold text-primary sm:text-3xl lg:text-[2.5rem]"
          >
            People who&rsquo;ve been carrying it a long time
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
            Trauma doesn&rsquo;t look one way, and neither do the people who
            come to us. Prism may be worth discussing if you are:
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {tiles.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="rounded-2xl border border-border bg-card p-6 shadow-soft transition-all duration-300 hover:border-accent/40 hover:shadow-premium"
            >
              <Icon className="h-7 w-7 text-accent" aria-hidden="true" />
              <h3 className="mt-4 font-headings text-base font-semibold text-primary">
                {title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground">
                {body}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-10 max-w-3xl text-base leading-relaxed text-muted-foreground sm:text-lg">
          You don&rsquo;t need to have it all figured out before you call.
          Telling us what you&rsquo;ve noticed is enough to start.
        </p>
      </div>
    </section>
  );
}
